export const navSections = [
  { id: "about", label: "About" },
  { id: "teams", label: "Teams" },
  { id: "mentors", label: "Mentors" },
  { id: "program", label: "Program" },
  { id: "prizes", label: "Prizes" },
  { id: "live", label: "Live" },
];

export type HeroProduct = "speaker" | "motor";

export interface HeroSlide {
  id: string;
  title: string[];
  body: string;
  product: HeroProduct;
  /** split: copy left, product right · stacked: headline on top, wide product below */
  layout: "split" | "stacked";
  figure: string;
  primary: { label: string; href: string };
  secondary?: { label: string; href: string };
}

export const heroSlides: HeroSlide[] = [
  {
    id: "build",
    title: ["From idea", "to working", "prototype"],
    body: "Five cross-border teams from Brazil and India design, wire and build a hardware product from scratch.",
    product: "speaker",
    layout: "split",
    figure: "Fig. 01 — Smart speaker",
    primary: { label: "Meet the teams", href: "#teams" },
    secondary: { label: "Program", href: "#program" },
  },
  {
    id: "demo",
    title: ["Business students.", "No prior hardware experience."],
    body: "The entrepreneurs are building physical products for the first time. Working alongside engineering students, they use AI tools, expert mentorship, and Circuit Launch’s labs to develop working prototypes.",
    product: "motor",
    layout: "stacked",
    figure: "Fig. 02 — Brushless drone motor",
    primary: { label: "Explore the program", href: "#program" },
  },
];

export const heroTaglines = ["Six days of building", "Brazil meets India", "Live Demo Day · Oct 13"];

export const aboutCopy = {
  headline: "Learn entrepreneurship by building something real.",
  lead: "The Hardware Hackathon brings students into the workshop to discover what it takes to turn an idea into a product—and a product into a business.",
  body: [
    "Created by Link School of Business and Circuit Launch, the program combines hardware prototyping, AI tools, market validation, and expert mentorship in an intensive week of building in Mountain View, California.",
    "This edition brings together six students from Brazil and five from India, culminating in a Demo Day where teams present their prototypes and business cases to investors.",
  ],
};

export const partnerNames = ["Link School of Business", "Mahindra University", "Circuit Launch"];

export const programImage =
  "https://cdn.magicpatterns.com/patterns/generated-images/17b1896a-a745-44f3-844e-6702a1e28e70.jpg";
